import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function InstallDesktopIcon(props: IconProps) {
    return <Icon {...props} iconKey={"install_desktop"}/>
}
